import React, {useEffect, useState} from "react";

import {useTranslation} from "react-i18next";
import useFetch, {CachePolicies} from "use-http";
import PrivacyToggle from "./PrivacyToggle";
import styles from "./PrivacyCommunitySetting.module.css";
import {getUserData} from "../../../service/auth.service";
import {useParams} from "react-router-dom";

const preferItemKey = {
  LOCATION_ANNOUNCE: "location-announce",
  LOCATION_ACCESS: "location-access",
  EMERGERCY_ALERT: "emergengy-alert",
};

const PrivacyCommunitySetting = (props: any) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [userPrefer, setUserPrefer] = useState({
    [preferItemKey.LOCATION_ANNOUNCE]: "false",
    [preferItemKey.LOCATION_ACCESS]: "false",
    [preferItemKey.EMERGERCY_ALERT]: "false",
  });

  const [groupData, setGroupData] = useState<any>(null);

  const api = useFetch(window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL, {
    cachePolicy: CachePolicies.NO_CACHE,
  });

  const apiMe = useFetch(window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `/api/v1/users/me`, {
    cachePolicy: CachePolicies.NO_CACHE,
  });

  const apiGetGroupPrefer = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `api/v1/users/get/group-preference`,
    {
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  const apiUpdateGroupPrefer = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `api/v1/users/group-preference`,
    {
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  const apiGroupMember = useFetch(
      window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `/api/v2/groups/members/${id}`,
      {
        cachePolicy: CachePolicies.NO_CACHE,
      }
  );

  const getGroupDetail = async () => {
    try {
      const data = await api.get(`/api/v2/groups/${id}`);
      const membersRes = await apiGroupMember.get();

      const isInGroup = data?.members?.some((member: any) => {
        return member.userID === getUserData().username || member.userID === getUserData().id;
        ;
      });

      if (isInGroup) {
        setGroupData(data);
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    getGroupDetail();
  }, [])

  const getGroupPreference = async () => {
    try {
      let res = await apiGetGroupPrefer.post({
        groupID: id,
      });

      const resMe = await apiMe.get();

      let groupPreferList = resMe?.userGroupPrefer?.filter((prefer: any) => {
        return prefer.type === groupData.type;
      });
      if (res.length > 0) {
        groupPreferList = res;
      }
      let preferList = Object.assign({}, userPrefer);
      groupPreferList.forEach((prefer: any) => {
        preferList[prefer.key] = prefer.value;
      });
      setUserPrefer(preferList);
    } catch (e) {
      console.log("[GetGroupPreferenceError]", e);
    }
  };

  const updateGroupPrefer = async (preferList: any) => {
    let groupPrefer: any = [];
    Object.keys(preferList).forEach((key: any) => {
      let prefer = {
        key,
        value: preferList[key],
        type: null,
        groupID: id,
      };
      groupPrefer.push(prefer);
    });
    await apiUpdateGroupPrefer.post(groupPrefer);
  };

  const handleChangeGroupPreference = (key: string) => {
    let value = !(userPrefer[key] === "true");
    let preferList = Object.assign({}, userPrefer);
    preferList[key] = value.toString();
    setUserPrefer(preferList);
    updateGroupPrefer(preferList);
  };

  useEffect(() => {
    if (!groupData) return;
    getGroupPreference();
  }, [groupData]);

  return (
    <div className={styles.container}>
      <div className={styles.header}>{t("Privacy")}</div>
      <hr />

      <PrivacyOption
        header={t("Location Announcement")}
        detail={t(
          "When you check in, location will be automatically announced to the group"
        )}
        on={userPrefer[preferItemKey.LOCATION_ANNOUNCE] === "true"}
        onToggle={() => {
          handleChangeGroupPreference(preferItemKey.LOCATION_ANNOUNCE);
        }}
      />
      <hr />

      <PrivacyOption
        header={t("Location Access")}
        detail={t("Friends in group can see your last checked in location")}
        on={userPrefer[preferItemKey.LOCATION_ACCESS] === "true"}
        onToggle={() => {
          handleChangeGroupPreference(preferItemKey.LOCATION_ACCESS);
        }}
      />
      <hr />

      <PrivacyOption
        header={t("Emergency Alert")}
        detail={t(
          "When you use emergency button, the status will alert to friends in the group"
        )}
        on={userPrefer[preferItemKey.EMERGERCY_ALERT] === "true"}
        onToggle={() => {
          handleChangeGroupPreference(preferItemKey.EMERGERCY_ALERT);
        }}
      />
      <hr />
    </div>
  );
};

const PrivacyOption = (props: any) => {
  // props = [header, detail, on, onToggle]
  return (
    <div className={styles.option}>
      <div style={{ width: "85%" }}>
        <div className={styles.optionHeader}>{props.header}</div>
        <div className={styles.optionDetail}>{props.detail}</div>
      </div>
      <PrivacyToggle checked={props.on} onClick={props.onToggle} />
    </div>
  );
};

export default PrivacyCommunitySetting;
